import { AbstractCategoryModel } from "@app/catalog-common";


export class SelectCategoryMessage {
  selected: AbstractCategoryModel;

  constructor(selected: AbstractCategoryModel) {
    if (selected != undefined) {
      this.selected = selected;
    }
  }
}